import { useTranslation } from 'react-i18next'

const Workflow = () => {
  const { t } = useTranslation()

  const steps = [
    {
      numberKey: 'workflow.step1.number',
      titleKey: 'workflow.step1.title',
      descKey: 'workflow.step1.description',
    },
    {
      numberKey: 'workflow.step2.number',
      titleKey: 'workflow.step2.title',
      descKey: 'workflow.step2.description',
    },
    {
      numberKey: 'workflow.step3.number',
      titleKey: 'workflow.step3.title',
      descKey: 'workflow.step3.description',
    },
  ]

  return (
    <section id="workflow" className="relative py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 text-crafter-accent font-mono text-sm mb-4">
            <span className="w-8 h-[1px] bg-crafter-accent/50" />
            <span>{t('workflow.sectionLabel')}</span>
            <span className="w-8 h-[1px] bg-crafter-accent/50" />
          </div>
          <h2 className="font-sans font-bold text-4xl md:text-5xl text-crafter-text mb-6">
            {t('workflow.title')}
          </h2>
          <p className="font-sans text-lg text-crafter-textDim max-w-2xl mx-auto">
            {t('workflow.description')}
          </p>
        </div>

        {/* Steps */}
        <div className="relative max-w-5xl mx-auto">
          {/* Connection line */}
          <div className="absolute top-24 left-0 right-0 h-[2px] bg-gradient-to-r from-crafter-accent/0 via-crafter-accent/30 to-crafter-accent/0 hidden lg:block" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-8">
            {steps.map((step, index) => (
              <div
                key={index}
                className="relative text-center group"
                style={{
                  animation: `fadeInUp 0.6s ease-out forwards ${index * 0.15}s`,
                  opacity: 0,
                }}
              >
                {/* Step number */}
                <div className="relative inline-flex items-center justify-center w-16 h-16 mb-6">
                  <div className="absolute inset-0 rounded-full bg-crafter-accent/10 group-hover:bg-crafter-accent/20 transition-colors" />
                  <span className="relative font-mono text-2xl font-bold text-crafter-accent">
                    {t(step.numberKey)}
                  </span>
                </div>

                {/* Content */}
                <h3 className="font-sans font-semibold text-xl text-crafter-text mb-3">
                  {t(step.titleKey)}
                </h3>
                <p className="font-sans text-crafter-textDim leading-relaxed">
                  {t(step.descKey)}
                </p>

                {/* Arrow (hidden on last item) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 -right-4 text-crafter-accent/30">
                    <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Use case cards */}
        <div className="mt-24 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <div className="p-6 bg-crafter-surface border border-crafter-accent/10 rounded-lg">
            <div className="font-mono text-xs text-crafter-accent mb-3">{t('workflow.useCaseLabel')}</div>
            <h4 className="font-sans font-semibold text-lg text-crafter-text mb-2">
              {t('workflow.aiSkillLibraries.title')}
            </h4>
            <p className="font-sans text-crafter-textDim text-sm">
              {t('workflow.aiSkillLibraries.description')}
            </p>
          </div>

          <div className="p-6 bg-crafter-surface border border-crafter-accent/10 rounded-lg">
            <div className="font-mono text-xs text-crafter-accent mb-3">{t('workflow.useCaseLabel')}</div>
            <h4 className="font-sans font-semibold text-lg text-crafter-text mb-2">
              {t('workflow.documentationManagement.title')}
            </h4>
            <p className="font-sans text-crafter-textDim text-sm">
              {t('workflow.documentationManagement.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Workflow
